export default "__VITE_ASSET__CIpZWLkB__"